import { ArrowForwardRounded } from "@mui/icons-material";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

import MainBorderButton from "../../components/MainBorderButton";
import MainText from "../../components/MainText";

import { ReactComponent as ReactLogo } from "../../assets/images/logo.svg";

export default function ConfirmPage() {
  const navigate = useNavigate();

  return (
    <Box
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        width={"90%"}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        flexDirection={"column"}
      >
        <Box
          sx={{
            width: "150px",
            height: "150px",
          }}
        >
          <ReactLogo style={{ width: "100%", height: "100%" }} />
        </Box>

        <Box py={1}>
          <MainText size="title">Circular UFRN</MainText>
        </Box>

        <MainText size="body" color="regular">
          Sua conta foi confirmada!
        </MainText>

        <Box my={2} width={"100%"}>
          <MainBorderButton
            text="Início"
            icon={<ArrowForwardRounded />}
            onClick={() => navigate("/")}
          />
        </Box>
      </Box>
    </Box>
  );
}
